// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"DD-z","smallCardRow":"ED-z","largeCardRow":"FD-z","productSearchRow":"GD-z","curatedRow":"HD-z"};